import { defineMessages } from 'react-intl';

export const mlbGlossary = defineMessages({
  pitchers: {
    id: 'MLB.Pitchers',
    defaultMessage: 'Pitchers',
  },
  reliefPitchers: {
    id: 'MLB.ReliefPitchers',
    defaultMessage: 'Relief Pitchers',
  },
  probablePitcher: {
    id: 'MLB.ProbablePitcher',
    defaultMessage: 'Probable Pitcher',
  },
  batters: {
    id: 'MLB.Batters',
    defaultMessage: 'Batters',
  },
});
